import script from "./UserCredito.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCredito.vue?vue&type=script&setup=true&lang=js"

import "./UserCredito.vue?vue&type=style&index=0&id=3a03827a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a03827a"]])

export default __exports__